import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from "react-router-dom";
import { useController, useSuspense } from '@rest-hooks/react';
import { useLogout } from "utils/useLogout";

import PageTop from 'components/PageTop';
import NavBar from 'components/navbar';

import OrganizationResource from 'resources/organization/OrganizationResource';

import Student from './Student';
import Teacher from './Teacher';
import Admin from './Admin';
import SwitcherMenu from './SwitcherMenu';

import CoursesList from 'utils/localStorage/CoursesList';
import UserName from 'utils/localStorage/UserName';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { usePermissions } from 'utils/context/PermissionsContext';

const contextMenu = {
  'student': Student,
  'teacher': Teacher,
  'admin': Admin
};

const drawerWidth = 260;

const Layout = ({back=false, context="student", activeMenuItem=0, pageInfo, cta, actionsMenu=null, statOverview=null, children }) => {
  const { fetch } = useController();
  const history = useHistory();
  const params = useParams();
  const logout = useLogout();

  const organizationId = parseInt(params.organizationId);

  const Menu = contextMenu[context];

  const coursesList = CoursesList.read();
  const organizations = useSuspense(OrganizationResource.list(), {id: organizationId});

  const handleGoBack = () => {
    if (typeof back === "string") {
      history.push(back);
    } else if (back === true) {
      history.goBack();
    }
  };

  const { setPermissions } = usePermissions();

  useEffect(() => {
    const getPermissions = async () => {
      const organizationId = params.organizationId ? parseInt(params.organizationId) : null;

      if (organizationId) {
        const {permissions} = await fetch(OrganizationResource.detail(), {id: organizationId});
        setPermissions(permissions);
      }
    };
    getPermissions ();
  }, [fetch]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        className='hidden'
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          <Menu organizationsList={ organizations } activeMenuItem={activeMenuItem} />

          <SwitcherMenu context={ context }
                        coursesList={ coursesList }
                        organizationsList={ organizations }
                        userName={ UserName.read() }
                        handleLogout={ logout }
          />

        </Drawer>
      </Box>

      <main className="grid">

        { back &&
          <div className="back-wrapper">
            <IconButton aria-label="back" size="large"
                         onClick={ handleGoBack } >
              <ArrowBackIcon fontSize="inherit" />
            </IconButton>
          </div>
        }

        <div className="content">

        <NavBar handleLogout={ logout } activeMenuItem={activeMenuItem}></NavBar>

          { pageInfo &&
            <PageTop pageInfo={ pageInfo } cta={ cta } actionsMenu={ actionsMenu } statOverview={ statOverview }/>
          }

          { children }
        </div>
      </main>
    </Box>
)};

Layout.propTypes = {
    context: PropTypes.string,
    back: PropTypes.bool,
    activeMenuItem: PropTypes.number,
    pageInfo: PropTypes.object,
    cta: PropTypes.node,
    actionsMenu: PropTypes.node,
    statOverview: PropTypes.node,
    children: PropTypes.node
};

export default Layout;
